import { Injectable } from '@angular/core';
import { Http, Response, Headers } from '@angular/http';

import { AppComponent } from '../app.component';

import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';

@Injectable()
export class LoginService {

	constructor(private http:Http) { }

	getToken(login:string, password:string){
		var data:string = `username=${login}&password=${password}&grant_type=password`;

		let headers = new Headers();
		headers.append('Content-Type', 'application/x-www-form-urlencoded');

		return this.http.post(AppComponent.DOMAIN + '/oauth/token', data, {
			headers: headers
		}).map( response => response.json() );
	}
}



// WEBPACK FOOTER //
// ./src/app/login/login.service.ts